import { render } from "./DashboardSidebarButton.vue?vue&type=template&id=b8e131ca&scoped=true"
import script from "./DashboardSidebarButton.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarButton.vue?vue&type=script&lang=js"

import "./DashboardSidebarButton.vue?vue&type=style&index=0&id=b8e131ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e131ca"]])

export default __exports__